'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
export const formatMediaBridgeObjectRecord = mediaObject => {
  return new ReferenceRecord({
    // object coordinate formatting to match our `hs_media_bridge_object`
    id: `${mediaObject.portalId}-${mediaObject.objectTypeId}-${mediaObject.objectId}`,
    label: mediaObject.properties.hs_title ? mediaObject.properties.hs_title.value : String(mediaObject.objectId),
    referencedObject: fromJS(mediaObject)
  });
};
const formatMediaBridgeObjects = response => {
  const results = indexBy(get('id'), List(response).map(formatMediaBridgeObjectRecord));

  // todo - unsure if/how pagination could work. hoping the endpoint delivering the 100-1k? closest matching objects suffices
  return {
    count: results.size,
    offset: results.size,
    hasMore: true,
    results
  };
};
export default formatMediaBridgeObjects;